export default (product) => {
    return ['coop', 'future_pow', 'prenup', 'undivided_estate_agreement', 'will'].indexOf(product) > -1;
};
